import React from 'react';

import { PrivacyPolicy, Submit } from 'components/Form/FormFields';

type FormFooterProps = {
  isTwoStepForm: boolean | undefined;
  curStep: number;
  handleNext: () => void;
  handleSubmit: () => void;
  isSubmitting: boolean;
  submitText: string;
  privacyPolicyHTML: string;
};

const FormFooter: React.FC<FormFooterProps> = ({
  isTwoStepForm,
  curStep,
  handleNext,
  handleSubmit,
  isSubmitting,
  submitText,
  privacyPolicyHTML,
}) => {
  if (isTwoStepForm && curStep === 0) {
    return <Submit key="Next" handleSubmit={handleNext} label="Next" />;
  }

  return (
    <>
      <Submit key="Submit" handleSubmit={handleSubmit} label={submitText || 'Submit'} isDisabled={isSubmitting} />
      <PrivacyPolicy key="PrivacyPolicy" privacyPolicyHTML={privacyPolicyHTML} />
    </>
  );
};

export default FormFooter;
